import * as httpClient from './_httpClient';
import * as authService from './authService';
import * as userService from './userService';
import * as domicileService from './domicileService';
import * as publicationService from './publicationService';
import * as evaluationService from './evaluationService';
import * as classificationService from './classificationService';
import * as institutionService from './institutionService';
import * as mentorService from './mentorService';
import * as registrationService from './registrationService';
import * as universityService from './universityService';
import * as capacityBuildingService from './capacityBuildingService';
import * as attendanceService from './attendanceService';
import * as bumdesService from './bumdesService';
import * as veciService from './veciService';
import * as leadershipService from './leadershipService';
import * as bmcService from './bmcService';
import * as dashboardService from './dashboardService';
import * as miscService from './miscService';
import * as batchService from './batchService';
import * as programSectionsService from './programSectionsService';
import * as notificationService from './notificationService';

const api = {
  // Token Management
  putAccessToken: httpClient.putAccessToken,
  getAccessToken: httpClient.getAccessToken,
  putRefreshToken: httpClient.putRefreshToken,
  getRefreshToken: httpClient.getRefreshToken,
  deleteToken: httpClient.deleteToken,

  // Auth Service
  register: authService.register,
  forgetPassword: authService.forgetPassword,
  changePassword: authService.changePassword,
  login: authService.login,
  loginAsEmpBcf: authService.loginAsEmpBcf,
  loginAsMentors: authService.loginAsMentors,
  refreshToken: authService.refreshToken,
  getSessionContext: authService.getSessionContext,
  switchBatchContext: authService.switchBatchContext,

  // User Service
  getOwnProfile: userService.getOwnProfile,
  getOwnFullProfile: userService.getOwnFullProfile,
  getOwnBCFProfile: userService.getOwnBCFProfile,
  getGlobalProfile: userService.getGlobalProfile,
  getCheckUsersByNim: userService.getCheckUsersByNim,
  getProfileByNim: userService.getProfileByNim,
  updateProfile: userService.updateProfile,
  updateProfilePicture: userService.updateProfilePicture,
  getAllUsers: userService.getAllUsers,
  getUsersById: userService.getUsersById,
  assignUserInstitution: userService.assignUserInstitution,
  exportUsers: userService.exportUsers,

  // Domicile Service
  getProvincies: domicileService.getProvincies,
  getRegenciesByProvincies: domicileService.getRegenciesByProvincies,
  getDistrictsByRegencies: domicileService.getDistrictsByRegencies,
  getVillagesByDistricts: domicileService.getVillagesByDistricts,

  // Publication Service
  searchPublications: publicationService.searchPublications,
  getPublicationsBySlug: publicationService.getPublicationsBySlug,
  getArticles: publicationService.getArticles,
  getSpecificArticles: publicationService.getSpecificArticles,
  getPublicationsAdmin: publicationService.getPublicationsAdmin,
  getStatusPublicationsAdmin: publicationService.getStatusPublicationsAdmin,
  getPublicationsById: publicationService.getPublicationsById,
  createPublicationReview: publicationService.createPublicationReview,
  updatePublicationReview: publicationService.updatePublicationReview,
  deletePublicationReview: publicationService.deletePublicationReview,
  updatePublicationStatusHistory:
    publicationService.updatePublicationStatusHistory,

  // Evaluation Service
  getPATPeers: evaluationService.getPATPeers,
  postPATEvaluation: evaluationService.postPATEvaluation,
  getClassificationsPAT: classificationService.getClassificationsPAT,
  getFinalEvaluations: evaluationService.getFinalEvaluations,
  refreshFinalEvaluations: evaluationService.refreshFinalEvaluations,
  generateFinalEvaluations: evaluationService.generateFinalEvaluations,
  getAllEvaluations: evaluationService.getAllEvaluations,
  getMentorEvaluations: evaluationService.getMentorEvaluations,
  getEvaluationsById: evaluationService.getEvaluationsById,
  getPATEvaluationsReceivedById:
    evaluationService.getPATEvaluationsReceivedById,
  getPATEvaluationsGivenById: evaluationService.getPATEvaluationsGivenById,
  deletePATEvaluationById: evaluationService.deletePATEvaluationById,
  putAdminPATEvaluation: evaluationService.putAdminPATEvaluation,
  resetMentorsEvaluations: evaluationService.resetMentorsEvaluations,
  adminChangeStudentMentor: evaluationService.adminChangeStudentMentor,
  addAdminEvaluation: evaluationService.addAdminEvaluation,
  updateEvaluation: evaluationService.updateEvaluation,
  updateEvaluationNote: evaluationService.updateEvaluationNote,
  getFinalHardSkillEvaluations: evaluationService.getFinalHardSkillEvaluations,
  updateFinalHardSkillEvaluations:
    evaluationService.updateFinalHardSkillEvaluations,
  getFinalSoftSkillEvaluations: evaluationService.getFinalSoftSkillEvaluations,
  updateFinalSoftSkillEvaluations:
    evaluationService.updateFinalSoftSkillEvaluations,
  addSoftSkillEvaluation: evaluationService.addSoftSkillEvaluation,
  addHardSkillEvaluation: evaluationService.addHardSkillEvaluation,
  addMentorEvaluation: evaluationService.addMentorEvaluation,
  deleteStudentsEvaluation: evaluationService.deleteStudentsEvaluation,
  assignStudentsEvaluation: evaluationService.assignStudentsEvaluation,
  getPendingCertificates: evaluationService.getPendingCertificates,
  issueCertificateManually: evaluationService.issueCertificateManually,

  // Classification Service
  addClassifications: classificationService.addClassifications,
  updateClassifications: classificationService.updateClassifications,
  getClassificationsHardskill:
    classificationService.getClassificationsHardskill,
  getClassificationsHardskillByDivisiLembagaId:
    classificationService.getClassificationsHardskillByDivisiLembagaId,
  getClassificationsBCF: classificationService.getClassificationsBCF,
  getClassificationsBCFByUserId:
    classificationService.getClassificationsBCFByUserId,
  getClassificationsSoftskill:
    classificationService.getClassificationsSoftskill,
  getClassificationFinalTypes: classificationService.getClassificationFinalTypes,
  addClassificationsBCF: classificationService.addClassificationsBCF,
  updateClassificationsBCF: classificationService.updateClassificationsBCF,

  // Institution Service
  addInstitutions: institutionService.addInstitutions,
  getInstitutions: institutionService.getInstitutions,
  getInstitutionsOptions: institutionService.getInstitutionsOptions,
  getInstitutionsDivisionOptions:
    institutionService.getInstitutionsDivisionOptions,
  getInstitutionDetailById: institutionService.getInstitutionDetailById,
  updateInstitution: institutionService.updateInstitution,
  deleteInstitution: institutionService.deleteInstitution,
  getInstitutionProvinces: institutionService.getInstitutionProvinces,
  getInstitutionById: institutionService.getInstitutionById,
  getDivisions: institutionService.getDivisions,
  addMasterDivision: institutionService.addMasterDivision,
  updateMasterDivision: institutionService.updateMasterDivision,
  deleteMasterDivision: institutionService.deleteMasterDivision,
  addDivisionByInstitution: institutionService.addDivisionByInstitution,
  getDivisionsByInstitution: institutionService.getDivisionsByInstitution,
  getDivisionInstitutionDetail: institutionService.getDivisionInstitutionDetail,
  updateDivisionByInstitution: institutionService.updateDivisionByInstitution,
  getDivisionByInstitutionId: institutionService.getDivisionByInstitutionId,

  // Mentor Service
  getMentorInstitutions: mentorService.getMentorInstitutions,
  getMentorInstitutionById: mentorService.getMentorInstitutionById,
  getClassificationsHardskillByMentor:
    mentorService.getClassificationsHardskillByMentor,
  addMentors: mentorService.addMentors,
  deleteMentorById: mentorService.deleteMentorById,
  getMentors: mentorService.getMentors,
  getMentorById: mentorService.getMentorById,
  generateStudents: mentorService.generateStudents,
  getMentorInstitutionOptions: mentorService.getMentorInstitutionOptions,
  getMentorInstitutionDivisionOptions:
    mentorService.getMentorInstitutionDivisionOptions,
  checkMentorEmail: mentorService.checkMentorEmail,
  getMentorHistory: mentorService.getMentorHistory,
  getMentorDirectory: mentorService.getMentorDirectory,
  getMentorByUserId: mentorService.getMentorByUserId,
  updateMentorProfile: mentorService.updateMentorProfile,
  addMentorDivision: mentorService.addMentorDivision,

  // Registration Service
  getRegistrations: registrationService.getRegistrations,
  getRegistrationsDetail: registrationService.getRegistrationsDetail,
  addRegistrations: registrationService.addRegistrations,
  getRegistrationsUsers: registrationService.getRegistrationsUsers,
  getRegistrationsJourney: registrationService.getRegistrationsJourney,
  patchRegistrationsJourney: registrationService.patchRegistrationsJourney,
  getRegistrationsJourneyConfig: registrationService.getRegistrationsJourneyConfig,
  upsertRegistrationsJourneyConfig:
    registrationService.upsertRegistrationsJourneyConfig,
  updateRegistrationAcceptanceStatus:
    registrationService.updateRegistrationAcceptanceStatus,
  getStatusAcceptance: registrationService.getStatusAcceptance,
  getRegistrationsStatusAcceptanceOptions:
    registrationService.getRegistrationsStatusAcceptanceOptions,
  getRegistrationsInstitutions:
    registrationService.getRegistrationsInstitutions,
  getRegistrationsInstitutionsDetail:
    registrationService.getRegistrationsInstitutionsDetail,
  getProgramOffered: registrationService.getProgramOffered,

  // University Service
  getOptionsUniversities: universityService.getOptionsUniversities,
  getUniversities: universityService.getUniversities,
  getUniversityDetail: universityService.getUniversityDetail,
  addUniversities: universityService.addUniversities,
  updateUniversities: universityService.updateUniversities,
  getMajorsByUniversity: universityService.getMajorsByUniversity,
  addMajor: universityService.addMajor,
  requestAddPendingUniversityRegistration:
    universityService.requestAddPendingUniversityRegistration,
  getMajors: universityService.getMajors,

  // Capacity Building Service
  getCapacityBuilding: capacityBuildingService.getCapacityBuilding,
  getCapacityBuildingDetail: capacityBuildingService.getCapacityBuildingDetail,
  addCapacityBuilding: capacityBuildingService.addCapacityBuilding,
  addQuestionForCapacityBuilding:
    capacityBuildingService.addQuestionForCapacityBuilding,
  getTestCapacityBuilding: capacityBuildingService.getTestCapacityBuilding,
  getTestQuestionCapacityBuilding:
    capacityBuildingService.getTestQuestionCapacityBuilding,
  submitTestCapacityBuilding:
    capacityBuildingService.submitTestCapacityBuilding,
  getAnalyticsCapacityBuildingImprovementKnowledge:
    capacityBuildingService.getAnalyticsCapacityBuildingImprovementKnowledge,
  submitAssignmentCapacityBuilding:
    capacityBuildingService.submitAssignmentCapacityBuilding,
  updateCapacityBuilding: capacityBuildingService.updateCapacityBuilding,
  getTaskById: capacityBuildingService.getTaskById,
  updateTask: capacityBuildingService.updateTask,
  deleteTask: capacityBuildingService.deleteTask,
  getTestById: capacityBuildingService.getTestById,
  updateTest: capacityBuildingService.updateTest,
  deleteTest: capacityBuildingService.deleteTest,
  addCapacityBuildingMaterial: capacityBuildingService.addCapacityBuildingMaterial,
  deleteCapacityBuildingMaterial: capacityBuildingService.deleteCapacityBuildingMaterial,
  gradeTaskSubmission: capacityBuildingService.gradeTaskSubmission,

  // Attendance Service
  getAttendancesAllUsers: attendanceService.getAttendancesAllUsers,
  getAttendancesAllUsersByMentor:
    attendanceService.getAttendancesAllUsersByMentor,
  getAttendancesDetailUsers: attendanceService.getAttendancesDetailUsers,
  submitAttendances: attendanceService.submitAttendances,
  verifyAttendances: attendanceService.verifyAttendances,
  getTodayAttendance: attendanceService.getTodayAttendance,
  getAttendanceByDate: attendanceService.getAttendanceByDate,
  getAttendanceQuota: attendanceService.getAttendanceQuota,
  getAttendanceHistory: attendanceService.getAttendanceHistory,
  clockIn: attendanceService.clockIn,
  requestTolerance: attendanceService.requestTolerance,
  clockOut: attendanceService.clockOut,
  submitLogbook: attendanceService.submitLogbook,
  getAttendances: attendanceService.getAttendances,
  getAttendanceDetail: attendanceService.getAttendanceDetail,
  reviewTolerance: attendanceService.reviewTolerance,
  getAdminAttendanceQuota: attendanceService.getAdminAttendanceQuota,
  getAdminAttendanceHistory: attendanceService.getAdminAttendanceHistory,
  getMentorAttendances: attendanceService.getMentorAttendances,
  getMentorAttendanceDetail: attendanceService.getMentorAttendanceDetail,
  reviewMentorTolerance: attendanceService.reviewMentorTolerance,
  getMentorAttendanceQuota: attendanceService.getMentorAttendanceQuota,
  getMentorAttendanceHistory: attendanceService.getMentorAttendanceHistory,
  syncMentorAttendanceScore: attendanceService.syncMentorAttendanceScore,

  // BUMDes Service
  getPreSurveyBumdes: bumdesService.getPreSurveyBumdes,
  getPreSurveyBumdesStats: bumdesService.getPreSurveyBumdesStats,
  getPreSurveyBumdesDetail: bumdesService.getPreSurveyBumdesDetail,
  getBumdesOptions: bumdesService.getBumdesOptions,
  getBumdesAutofill: bumdesService.getBumdesAutofill,
  submitPreSurveyBumdes: bumdesService.submitPreSurveyBumdes,
  updatePreSurveyBumdes: bumdesService.updatePreSurveyBumdes,
  registerBumdes: bumdesService.registerBumdes,
  getBumdesRegistrations: bumdesService.getBumdesRegistrations,
  getBumdesRegistrationDetail: bumdesService.getBumdesRegistrationDetail,
  approveBumdesRegistration: bumdesService.approveBumdesRegistration,
  rejectBumdesRegistration: bumdesService.rejectBumdesRegistration,
  getBumdesList: bumdesService.getBumdesList,
  getBumdesDetail: bumdesService.getBumdesDetail,
  deleteBumdes: bumdesService.deleteBumdes,
  getBUMDesAwardWinners: bumdesService.getBUMDesAwardWinners,
  getBUMDesAwardRankings: bumdesService.getBUMDesAwardRankings,
  recalculateBUMDesAwardWinners: bumdesService.recalculateBUMDesAwardWinners,
  getBumdesPreSurveyAutofill: bumdesService.getBumdesPreSurveyAutofill,

  // VECI Service
  getVECIIdentity: veciService.getVECIIdentity,
  getVECIQuestions: veciService.getVECIQuestions,
  submitVECISurvey: veciService.submitVECISurvey,
  saveDraftVECISurvey: veciService.saveDraftVECISurvey,
  updateDraftVECISurvey: veciService.updateDraftVECISurvey,
  getVECISurveyResult: veciService.getVECISurveyResult,
  getMeBumdesVECIResult: veciService.getMeBumdesVECIResult,
  getVECISurveyComparison: veciService.getVECISurveyComparison,
  checkVECIAnomalies: veciService.checkVECIAnomalies,
  getVECISurveyResults: veciService.getVECISurveyResults,
  getVECISurveys: veciService.getVECISurveys,
  getVECISurveyDetail: veciService.getVECISurveyDetail,
  updateVECISurveyStatus: veciService.updateVECISurveyStatus,
  getVECIHeatmap: veciService.getVECIHeatmap,
  getVECIDashboard: veciService.getVECIDashboard,
  getSurveyIdentity: veciService.getSurveyIdentity,
  submitSurveyVECI: veciService.submitSurveyVECI,

  // Leadership Service
  getSurveyLeadershipIdentity: leadershipService.getSurveyLeadershipIdentity,
  getSurveyLeadershipQuestions: leadershipService.getSurveyLeadershipQuestions,
  saveDraftSurveyLeadership: leadershipService.saveDraftSurveyLeadership,
  submitSurveyLeadership: leadershipService.submitSurveyLeadership,
  getSurveyLeadershipDashboard: leadershipService.getSurveyLeadershipDashboard,
  getSurveyLeadershipSummary: leadershipService.getSurveyLeadershipSummary,
  getSurveyLeadershipDetail: leadershipService.getSurveyLeadershipDetail,

  // BMC Service
  getBMCIdentity: bmcService.getBMCIdentity,
  getBMCQuestions: bmcService.getBMCQuestions,
  saveDraftBMC: bmcService.saveDraftBMC,
  updateDraftBMC: bmcService.updateDraftBMC,
  submitBMC: bmcService.submitBMC,
  getBMCResult: bmcService.getBMCResult,
  getBMCAnswers: bmcService.getBMCAnswers,
  getAllBMCResults: bmcService.getAllBMCResults,
  getBMCHistory: bmcService.getBMCHistory,
  getBMCSurveys: bmcService.getBMCSurveys,
  getBMCSurveyDetail: bmcService.getBMCSurveyDetail,
  updateBMCSurveyStatus: bmcService.updateBMCSurveyStatus,
  getBMCSurveyHistory: bmcService.getBMCSurveyHistory,
  getBMCSurveyCompare: bmcService.getBMCSurveyCompare,

  // Dashboard Service
  getAdminDashboard: dashboardService.getAdminDashboard,
  getHasUpdatedStudent: dashboardService.getHasUpdatedStudent,
  getHasUpdatedStudentList: dashboardService.getHasUpdatedStudentList,
  getMasterProgramSections: programSectionsService.getMasterProgramSections,
  addMasterProgramSection: programSectionsService.addMasterProgramSection,
  updateMasterProgramSection: programSectionsService.updateMasterProgramSection,
  deleteMasterProgramSection: programSectionsService.deleteMasterProgramSection,
  reorderMasterProgramSections: programSectionsService.reorderMasterProgramSections,
  getProgramBatchSectionsForManagement:
    programSectionsService.getProgramBatchSectionsForManagement,
  addProgramBatchSection: programSectionsService.addProgramBatchSection,
  updateProgramBatchSection: programSectionsService.updateProgramBatchSection,
  deleteProgramBatchSection: programSectionsService.deleteProgramBatchSection,
  excludeProgramBatchSection: programSectionsService.excludeProgramBatchSection,
  getNewUsersRegistrations: dashboardService.getNewUsersRegistrations,
  getCountUsersRegistrationsByUniversities:
    dashboardService.getCountUsersRegistrationsByUniversities,
  getCountActiveUsersGroupByInstitution: dashboardService.getCountActiveUsersGroupByInstitution,
  getTimelineByBatchId: dashboardService.getTimelineByBatchId,

  // Misc Service
  getBatchOptions: miscService.getBatchOptions,
  getBatchOptionsByInstitutionsId: miscService.getBatchOptionsByInstitutionsId,
  getBatchOptionsMentors: miscService.getBatchOptionsMentors,
  getRecommendationsLetter: miscService.getRecommendationsLetter,
  getFinalEvaluationsById: miscService.getFinalEvaluationsById,
  getAlumniOptions: miscService.getAlumniOptions,

  // Batch Service
  getBatches: batchService.getBatches,
  getBatchById: batchService.getBatchById,
  addBatch: batchService.addBatch,
  updateBatch: batchService.updateBatch,
  getThirdTierProgramOptions: batchService.getThirdTierProgramOptions,
  getBatchMainOptions: batchService.getBatchMainOptions,
  getStatusAcceptanceConfig: batchService.getStatusAcceptanceConfig,
  upsertStatusAcceptanceConfig: batchService.upsertStatusAcceptanceConfig,
  getBatchDocumentTemplate: batchService.getBatchDocumentTemplate,
  updateBatchDocumentTemplate: batchService.updateBatchDocumentTemplate,

  // Notification Service
  getNotifications: notificationService.getNotifications,
  getUnreadNotificationCount: notificationService.getUnreadNotificationCount,
  markNotificationRead: notificationService.markNotificationRead,
  markAllNotificationsRead: notificationService.markAllNotificationsRead,
  getMyNotifications: notificationService.getMyNotifications,
  getMyUnreadNotificationCount: notificationService.getMyUnreadNotificationCount,
  markMyNotificationRead: notificationService.markMyNotificationRead,
  markAllMyNotificationsRead: notificationService.markAllMyNotificationsRead,
};

export default api;
